import { checkToken } from 'api/authApi';
import { useEffect } from 'react';
import WebUtils from 'util/WebUtils';

const TIMEOUT = 10 * 1000;

export function AuthProvider({children}) {
  const cookieLang = WebUtils.getCookie('lang');
  const lang = localStorage.getItem('lang') || this.getBrowserLang();
  if (cookieLang != lang) {
    WebUtils.setCookie('lang', lang);
    window.location.reload();
  }
  useEffect(() => {
    const intervalId = setInterval(() => {
      checkToken(/* () => clearInterval(intervalId) */);
    }, TIMEOUT);
    return () => clearInterval(intervalId);
  }, []);

  return children;
}